module.exports = __webpack_public_path__ + "img/Sativa.0fb49dc5.svg";